// @flow
import * as React from 'react';
import AppBarActionsContext from '../config/actionsContext';

export default function useAppBarActions() {
  return React.useContext(AppBarActionsContext);
}
